export const shallowUniqueFilter = (value: string, index: number, array: string[]) => array.indexOf(value) === index;
